export default "/images/dmca-protected.png?e1a5f2e92cace8cf3c591b3035c67698";